var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldCreateWorkspace)?_c('Error',{attrs:{"error":"should-create-workspace"}}):_c('div',{attrs:{"id":"calendar"}},[_c('section',[_c('WeekCalendar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }